import { render, staticRenderFns } from "./TabMetadataBusinessTermsComponent.vue?vue&type=template&id=7a1d34ee&scoped=true&lang=pug"
import script from "./TabMetadataBusinessTermsComponent.vue?vue&type=script&lang=js"
export * from "./TabMetadataBusinessTermsComponent.vue?vue&type=script&lang=js"
import style0 from "./TabMetadataBusinessTermsComponent.vue?vue&type=style&index=0&id=7a1d34ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1d34ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a1d34ee')) {
      api.createRecord('7a1d34ee', component.options)
    } else {
      api.reload('7a1d34ee', component.options)
    }
    module.hot.accept("./TabMetadataBusinessTermsComponent.vue?vue&type=template&id=7a1d34ee&scoped=true&lang=pug", function () {
      api.rerender('7a1d34ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/components/TabMetadataBusinessTermsComponent.vue"
export default component.exports